import React, { useEffect, useState } from "react";
import jci from "../../../../public/assets/images/updated_jci.png";
import united from "../../../images/jci.png";
import united_health from "../../../images/jci.png";
import { IMAGE_URL } from "../../../constants";
import { thirdparty } from "../../..";
const JCI = () => {
  const [fatchdata, setFatchdata] = useState([]);

  useEffect(() => {
    fetchData(); // Initial data fetch
  }, []);
  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/settings/2"); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  return (
    <div>
      <section
        style={{ backgroundColor: "#F7F5EF" }}
        className="news-events pt-0 pb-0"
        id="hr-lines"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <h3
            className="text-left"
            style={{
              color: "#af9763",
              fontSize: "30px",
              fontWeight: "600",
              textAlign: "center",
              width: "100%",
            }}
          >
            News
          </h3>
          {/* <img src="/assets/images/department_under.png" alt="" /> */}
        </div>
        <div
          className="container jci jciContainer pb-3"
          style={{
            // backgroundImage: `url(${jci})`,

            // height: "500px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="row jci-row justify-content-between"
            style={{ width: "100%", margin: "0 auto" }}
          >
            <div className="col-lg-5 jci-content">
              <a
                href="https://www.dhakatribune.com/business/323389/united-hospital-attains-jci-accreditation"
                target="_blank"
                style={{ textDecoration: "none" }}
              >
                <div
                  className="div1"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    // maxWidth: "300px",
                    // width: "100%",
                  }}
                >
                  <div className="jciImg mb-3">
                    <img
                      style={{ borderRadius: "5px", width: "100%" }}
                      // className="img-2"
                      src="/assets/images/jci_img.jpg"
                      alt=""
                    />
                  </div>
                  <div className="">
                    <h3 className="fw-normal">
                      United Hospital attains JCI accreditation
                    </h3>
                  </div>
                  <div className="jci_text">
                    {/* <h2>United Hospital attains JCI accreditation</h2> */}
                    <p className="mb-2">
                      A remarkable feat in healthcare excellence
                    </p>
                    <span
                      style={{
                        backgroundColor: "#0c807d",
                        padding: "3px 5px",
                        color: "#ffffff",
                        borderRadius: "5px",
                      }}
                    >
                      Read More
                    </span>
                  </div>
                </div>
              </a>
            </div>

            <div
              className="col-lg-7 videoContainer"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                // maxWidth: "500px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                }}
                dangerouslySetInnerHTML={{ __html: fatchdata.value }}
              >
                {/* {fatchdata.value} */}
                {/* <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/Vh979GprgoY?si=YcC9m2Em3oOiT-8r?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0&amp;mute=1"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                  style={{ width: "100%", height: "100%", borderRadius: "5px" }}
                ></iframe> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JCI;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/JCI.js